(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')) {
        activeMedia.loadContent();
      }
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pc-abonnement-club"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pc-club-explorer')) {
  customElements.define('pc-club-explorer', class extends HTMLElement {
    static quote(monthlyGrams, delivery, packaging) {
      if (!Number.isSafeInteger(monthlyGrams) || monthlyGrams < 500 || monthlyGrams % 500 !== 0 || !Number.isSafeInteger(monthlyGrams / 500 * 1290) || !['relay', 'home'].includes(delivery) || !['large', 'small'].includes(packaging)) throw new Error('Invalid quote selection');
      const months = monthlyGrams <= 1000 ? 2 : 1;
      const shipmentGrams = monthlyGrams * months;
      const smallOnly = monthlyGrams === 500 || packaging === 'small';
      const bigBags = smallOnly ? 0 : Math.floor(shipmentGrams / 1000);
      const smallBags = (shipmentGrams - bigBags * 1000) / 500;
      const coffee = shipmentGrams >= 1500 ? shipmentGrams / 500 * 1245 : 2580;
      const oneoffCoffee = bigBags * 2490 + smallBags * 1290;
      const shipping = shipmentGrams >= 1500 ? 0 : delivery === 'relay' ? 290 : 500;
      const oneoffShipping = shipmentGrams >= 2000 ? 0 : shipmentGrams === 1500 ? (delivery === 'home' ? 290 : 0) : (delivery === 'home' ? 500 : 290);
      const total = coffee + shipping;
      const oneoff = oneoffCoffee + oneoffShipping;
      return {monthlyGrams, shipmentGrams, months, bigBags, smallBags, coffee, shipping, total, monthly:total/months, oneoffCoffee, oneoffShipping, oneoff, saving:oneoff-total};
    }
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.words = JSON.parse(this.querySelector('[data-pcc-i18n]').textContent);
      this.money = new Intl.NumberFormat('fr-FR', {style:'currency', currency:'EUR'});
      this.customGrams = 3000;
      this.hasValidQuote = true;
      this.changeHandler = (event) => {
        if (event.target.matches('input[type="radio"][name^="pcc-"]')) this.renderQuote(true);
      };
      this.inputHandler = (event) => {
        if (event.target.matches('[data-custom-kg]')) this.renderQuote(true);
      };
      this.clickHandler = (event) => {
        const open = event.target.closest('[data-open-composer]');
        if (open) this.querySelector('pc-subscription-composer').open(open);
        const step = event.target.closest('[data-quantity-step]');
        if (step) {
          const field = this.querySelector('[data-custom-kg]');
          const current = field.valueAsNumber * 1000;
          const base = Number.isSafeInteger(current) && current >= 2500 && current % 500 === 0 ? current : this.customGrams;
          field.value = String(Math.max(2500, base + Number(step.dataset.quantityStep)) / 1000);
          this.renderQuote(true);
        }
        if (event.target.closest('[data-jump-result]')) this.jumpTo(this.querySelector('[data-pcc-result]'));
        const anchor = event.target.closest('a[href]');
        if (anchor && anchor.hash.startsWith('#pcc-')) {
          const target = this.querySelector(anchor.hash);
          if (target) {event.preventDefault();this.jumpTo(target);}
        }
      };
      this.addEventListener('change', this.changeHandler);
      this.addEventListener('input', this.inputHandler);
      this.addEventListener('click', this.clickHandler);
      this.renderQuote(false);
      if ('IntersectionObserver' in window) {
        this.calculatorVisible = false;
        this.resultVisible = false;
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.target.id === 'pcc-budget') this.calculatorVisible = entry.isIntersecting;
            else if (entry.target === this.querySelector('[data-pcc-result]')) this.resultVisible = entry.isIntersecting;
            else if (entry.target === this.querySelector('.pcc-hero-actions')) this.heroActionVisible = entry.isIntersecting;
            else if (entry.target === this.querySelector('.pcc-closing')) this.closingActionVisible = entry.isIntersecting;
            else if (entry.target === this) this.pageVisible = entry.isIntersecting;
          });
          this.updateDock();
        }, {threshold:0, rootMargin:'-110px 0px -75px 0px'});
        this.observer.observe(this.querySelector('#pcc-budget'));
        this.observer.observe(this.querySelector('[data-pcc-result]'));
        this.observer.observe(this.querySelector('.pcc-hero-actions'));
        this.observer.observe(this.querySelector('.pcc-closing'));
        this.observer.observe(this);
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.removeEventListener('change', this.changeHandler);
      this.removeEventListener('input', this.inputHandler);
      this.removeEventListener('click', this.clickHandler);
      this.initialized = false;
    }
    translate(key, values={}) {
      return Object.entries(values).reduce((text, [name, value]) => text.replaceAll('{'+name+'}', String(value)), this.words[key] || '');
    }
    euros(cents) { return this.money.format(cents / 100); }
    weight(grams) { return grams === 500 ? '500 g' : new Intl.NumberFormat('fr-FR').format(grams/1000)+' kg'; }
    updateDock() {
      this.querySelector('[data-dock]').hidden = this.pageVisible === false || !!this.heroActionVisible || !!this.closingActionVisible || !!this.querySelector('[data-compose-dialog]')?.open;
    }
    jumpTo(target) {
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({behavior:reduced?'auto':'smooth',block:'start'});
      const heading=target.querySelector('h2,h3') || target;
      heading.setAttribute('tabindex','-1');
      heading.focus({preventScroll:true});
    }
    renderQuote(announce) {
      const selected = this.querySelector('input[name="pcc-quantity"]:checked').value;
      const custom = selected === 'custom';
      const field = this.querySelector('[data-custom-kg]');
      const amount = custom ? field.valueAsNumber * 1000 : Number(selected);
      const valid = Number.isSafeInteger(amount) && amount >= (custom ? 2500 : 500) && amount % 500 === 0 && Number.isSafeInteger(amount / 500 * 1290);
      this.hasValidQuote = valid;
      this.querySelector('[data-custom-quantity]').hidden = !custom;
      this.querySelector('[data-custom-error]').hidden = !custom || valid;
      field.setAttribute('aria-invalid', String(custom && !valid));
      this.querySelector('[data-quantity-step="-500"]').disabled = valid && amount <= 2500;
      this.querySelector('.pcc-selected-benefits').hidden = !valid;
      this.querySelector('[data-pcc-result]').hidden = !valid;
      this.querySelector('.pcc-compare').hidden = !valid;
      this.querySelector('[data-invalid-quote]').hidden = valid;
      this.updateDock();
      if (!valid) {
        if (announce) this.querySelector('[data-status]').textContent = this.translate('d_invalid_quantity');
        return;
      }
      if (custom) this.customGrams = amount;
      const delivery = this.querySelector('input[name="pcc-delivery"]:checked').value;
      const packaging = this.querySelector('input[name="pcc-pack"]:checked').value;
      const q = this.constructor.quote(amount, delivery, packaging);
      const t = (key, values) => this.translate(key, values);
      const set = (selector, value) => {this.querySelector(selector).textContent=value;};
      const period = t(q.months === 2 ? 'd_bimonthly' : 'd_monthly');
      const packParts=[];
      if (q.bigBags) packParts.push(t(q.bigBags===1?'d_pack_big_one':'d_pack_big_many',{count:q.bigBags}));
      if (q.smallBags) packParts.push(t(q.smallBags===1?'d_pack_small_one':'d_pack_small_many',{count:q.smallBags}));
      const packs=packParts.join(t('d_pack_join'));
      this.querySelector('[data-pcc-pack]').hidden=amount===500;
      this.querySelector('[data-pcc-fixed]').hidden=amount!==500;
      set('[data-result-title]', t('d_quantity',{weight:this.weight(amount)}));
      set('[data-total]',this.euros(q.total));
      set('[data-period]',period);
      set('[data-average]',t('d_average',{amount:this.euros(q.monthly)}));
      this.querySelector('[data-average]').hidden=q.months===1;
      this.querySelector('.pcc-average-help').hidden=q.months===1;
      set('[data-shipment]',t('d_shipment',{weight:this.weight(q.shipmentGrams),packs}));
      set('[data-coffee]',this.euros(q.coffee));
      set('[data-shipping]',q.shipping?this.euros(q.shipping):t('free'));
      set('[data-price-relay]',q.shipmentGrams>=1500?t('free'):this.euros(290));
      set('[data-price-home]',q.shipmentGrams>=1500?t('free'):this.euros(500));
      set('[data-oneoff]',this.euros(q.oneoff));
      set('[data-subtotal]',this.euros(q.total));
      set('[data-saving-title]',q.saving>0?t('compare_save_title',{amount:this.euros(q.saving)}):t('compare_equal_title'));
      set('[data-saving-text]',t(q.saving>0?'compare_save_text':'compare_equal_text'));
      set('[data-basis]',t('compare_basis',{weight:this.weight(q.shipmentGrams),packs}));
      set('[data-selected-title]',t('d_selected_title',{weight:this.weight(amount)}));
      set('[data-selected-shipping-title]',t(q.shipping===0?'d_selected_shipping_free_title':'d_selected_shipping_paid_title'));
      set('[data-selected-shipping]',t(q.shipping===0?'d_selected_shipping_free':'d_selected_shipping_paid',{weight:this.weight(q.shipmentGrams),period}));
      set('[data-selected-mix-title]',t(q.shipmentGrams>=1500?'d_selected_mix_large_title':'d_selected_mix_small_title'));
      set('[data-selected-mix]',t(q.shipmentGrams>=1500?'d_selected_mix_large':'d_selected_mix_small'));
      if(announce) set('[data-status]',t('live_update',{amount:this.euros(q.total),period}));
    }
  });
}

if (!customElements.get('pc-subscription-composer')) {
  customElements.define('pc-subscription-composer', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.explorer = this.closest('pc-club-explorer');
      this.dialog = this.querySelector('[data-compose-dialog]');
      this.step = 1;
      this.lastCustomGrams = 3000;
      this.onChange = event => {
        if (event.target.matches('input[type="radio"]')) this.render();
      };
      this.onInput = event => {
        if (event.target.matches('input[type="number"]')) this.render();
      };
      this.onClick = event => {
        if (event.target.closest('[data-compose-finish]')) { this.startCheckout(); return; }
        if (event.target.closest('[data-compose-close]')) this.dialog.close();
        if (event.target.closest('[data-compose-next]') && this.canContinue()) this.showStep(this.step + 1);
        if (event.target.closest('[data-compose-back]')) this.showStep(this.step - 1);
        const edit = event.target.closest('[data-compose-edit]');
        if (edit) this.showStep(Number(edit.dataset.composeEdit));
        const quantity = event.target.closest('[data-compose-step]');
        if (quantity) {
          const field = this.querySelector('#pcc-compose-kg');
          const raw = field.valueAsNumber * 1000;
          const base = this.validQuantity(raw, 2500) ? raw : this.lastCustomGrams;
          field.value = String(Math.max(2500, base + Number(quantity.dataset.composeStep)) / 1000);
          this.render();
        }
        const counter = event.target.closest('[data-bag-change]');
        if (counter && this.quote) {
          const field = this.querySelector('#pcc-bag-' + counter.dataset.coffee + '-' + counter.dataset.size);
          const base = Number.isSafeInteger(field.valueAsNumber) && field.valueAsNumber >= 0 ? field.valueAsNumber : 0;
          field.value = String(Math.max(0, base + Number(counter.dataset.bagChange)));
          this.render();
        }
        const only = event.target.closest('[data-only-coffee]');
        if (only && this.quote) {
          this.querySelectorAll('[data-bag-count]').forEach(field => {
            field.value = field.dataset.coffee === only.dataset.onlyCoffee ? String(this.capacity(Number(field.dataset.size))) : '0';
          });
          this.render();
        }
      };
      this.onClose = () => {
        document.body.style.overflow = this.previousOverflow;
        this.syncToExplorer();
        this.explorer.updateDock();
        this.opener?.focus({preventScroll:true});
      };
      this.addEventListener('change', this.onChange);
      this.addEventListener('input', this.onInput);
      this.addEventListener('click', this.onClick);
      this.dialog.addEventListener('close', this.onClose);
      this.onCancel = event => { if (this.checkoutPending) event.preventDefault(); };
      this.dialog.addEventListener('cancel', this.onCancel);
    }
    disconnectedCallback() {
      if (this.dialog?.open) document.body.style.overflow = this.previousOverflow;
      this.removeEventListener('change', this.onChange);
      this.removeEventListener('input', this.onInput);
      this.removeEventListener('click', this.onClick);
      this.dialog?.removeEventListener('close', this.onClose);
      this.dialog?.removeEventListener('cancel', this.onCancel);
      this.ready = false;
    }
    buildCheckoutItems() {
      if (!this.quote || !this.allocationValid()) throw new Error('Complétez votre sélection de cafés avant de continuer.');
      const config = JSON.parse(this.explorer.querySelector('[data-pcc-shopify]').textContent);
      if (config.currency !== 'EUR') throw new Error('Choisissez le marché France pour payer votre abonnement en euros.');
      const q = this.quote;
      const codes = ['SOL', 'SIG', 'PAT', 'ESP'];
      const planId = String(config.plans[q.months]);
      const grind = this.checked('grind');
      const delivery = this.checked('delivery');
      let coffeeCents = 0;
      const items = [];
      this.querySelectorAll('[data-bag-count]').forEach(field => {
        const size = Number(field.dataset.size);
        const quantity = this.capacity(size) ? Number(field.value) : 0;
        if (!quantity) return;
        if (!Number.isSafeInteger(quantity) || quantity < 1) throw new Error('Vérifiez les quantités de café.');
        const code = codes[Number(field.dataset.coffee)];
        const sku = `ABO2-${code}-${grind === 'grain' ? 'G' : 'M'}-${size}${size === 500 && q.shipmentGrams >= 1500 ? '-VOL' : ''}${delivery === 'home' ? '-DOM' : ''}`;
        const variant = config.variants.find(candidate => candidate.sku === sku);
        const allocation = variant?.allocations.find(plan => String(plan.id) === planId && plan.recurring);
        if (!variant || !allocation || !Number.isSafeInteger(allocation.price)) throw new Error('Cette formule est momentanément indisponible. Contactez-nous pour votre abonnement.');
        if (!variant.available) throw new Error('Un café sélectionné n’est plus disponible. Modifiez votre composition.');
        coffeeCents += allocation.price * quantity;
        items.push({
          id: variant.id, quantity, selling_plan: Number(allocation.id),
          properties: {
            '_pc_subscription': 'patagonia-club-v2',
            '_pc_months': String(q.months),
            'Conditionnement': size === 1000 ? 'Sachet de 1 kg' : 'Sachet de 500 g',
            'Préparation': grind === 'grain' ? 'En grains' : 'Moulu',
            'Livraison récurrente': delivery === 'home' ? 'À domicile' : 'Point relais',
            'Envoi': this.weight(q.shipmentGrams) + (q.months === 2 ? ' tous les deux mois' : ' chaque mois')
          }
        });
      });
      if (!items.length || coffeeCents !== q.coffee) throw new Error('Le prix de votre sélection a changé. Rechargez la page pour vérifier le montant avant de payer.');
      return {items, coffeeCents, root: config.root.replace(/\/$/, '') + '/'};
    }
    async checkoutRequest(root, path, data) {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 20000);
      try {
        const response = await fetch(root + path, {
          method: data ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store', signal: controller.signal,
          headers: {'Accept': 'application/json', ...(data ? {'Content-Type': 'application/json'} : {})},
          ...(data ? {body: JSON.stringify(data)} : {})
        });
        const result = await response.json();
        if (!response.ok || result.status >= 400) throw new Error(typeof result.description === 'string' ? result.description : 'Le panier n’a pas pu être mis à jour. Réessayez.');
        return result;
      } finally { clearTimeout(timer); }
    }
    checkoutIdentity(item) {
      const properties = Object.entries(item.properties || {}).filter(([,value]) => value !== '').sort(([a],[b]) => a.localeCompare(b));
      return JSON.stringify([Number(item.variant_id || item.id), Number(item.selling_plan || item.selling_plan_allocation?.selling_plan.id), properties]);
    }
    async startCheckout() {
      if (this.checkoutPending) return;
      this.checkoutPending = true;
      const error = this.querySelector('[data-checkout-error]');
      const button = this.querySelector('[data-compose-finish]');
      error.hidden = true;
      const controls = [...this.querySelectorAll('button,input')].map(control => [control, control.disabled]);
      controls.forEach(([control]) => { control.disabled = true; });
      button.textContent = 'Préparation du paiement…';
      this.setAttribute('aria-busy', 'true');
      try {
        const {items: desired, coffeeCents, root} = this.buildCheckoutItems();
        const request = (path, data) => this.checkoutRequest(root, path, data);
        const managed = line => line.properties?._pc_subscription === 'patagonia-club-v2';
        let cart = await request('cart.js');
        if (cart.currency !== 'EUR') throw new Error('Choisissez le marché France pour payer votre abonnement en euros.');
        const wanted = new Map(desired.map(item => [this.checkoutIdentity(item), item]));
        const missing = desired.filter(item => !cart.items.some(line => managed(line) && this.checkoutIdentity(line) === this.checkoutIdentity(item)));
        // Add before replacing an earlier composition, so a stock error preserves it.
        if (missing.length) await request('cart/add.js', {items: missing});
        cart = await request('cart.js');
        for (let attempt = 0; attempt < 40; attempt++) {
          const kept = new Set();
          let change;
          for (const line of cart.items.filter(managed)) {
            const identity = this.checkoutIdentity(line);
            const match = wanted.get(identity);
            const quantity = match && !kept.has(identity) ? match.quantity : 0;
            kept.add(identity);
            if (line.quantity !== quantity) { change = {id: line.key, quantity}; break; }
          }
          if (!change) break;
          cart = await request('cart/change.js', change);
        }
        const lines = cart.items.filter(managed);
        if (lines.length !== desired.length || desired.some(item => !lines.some(line => this.checkoutIdentity(line) === this.checkoutIdentity(item) && line.quantity === item.quantity))) throw new Error('Le panier a changé. Réessayez pour vérifier votre composition.');
        if (lines.some(line => !line.selling_plan_allocation?.selling_plan.recurring_deliveries) || lines.reduce((total, line) => total + line.selling_plan_allocation.price * line.quantity, 0) !== coffeeCents) throw new Error('Le tarif de l’abonnement a changé. Rechargez la page avant de payer.');
        // Preserve other cart items. Shopify collects payment and creates the contract.
        window.location.assign(root + 'checkout');
      } catch (exception) {
        error.textContent = exception.name === 'AbortError' || exception instanceof TypeError ? 'La connexion a été interrompue. Votre composition est conservée ; réessayez pour accéder au paiement.' : exception.message;
        error.hidden = false;
        error.focus();
        controls.forEach(([control, disabled]) => { control.disabled = disabled; });
        button.textContent = 'Continuer vers le paiement';
        this.removeAttribute('aria-busy');
        this.checkoutPending = false;
      }
    }

    t(key, values) { return this.explorer.translate(key, values); }
    money(cents) { return this.explorer.euros(cents); }
    weight(grams) { return this.explorer.weight(grams); }
    set(selector, text) { this.querySelector(selector).textContent = text; }
    checked(name) { return this.querySelector('input[name="cmp-' + name + '"]:checked').value; }
    validQuantity(value, minimum=500) {
      return Number.isSafeInteger(value) && value >= minimum && value % 500 === 0 && Number.isSafeInteger(value / 500 * 1290);
    }
    open(opener) {
      if (this.dialog.open) return;
      this.opener = opener;
      const e = this.explorer;
      const selection = e.hasValidQuote ? e.querySelector('input[name="pcc-quantity"]:checked').value : '1000';
      this.querySelector('input[name="cmp-quantity"][value="' + selection + '"]').checked = true;
      if (selection === 'custom') this.querySelector('#pcc-compose-kg').value = e.querySelector('[data-custom-kg]').value;
      for (const name of ['pack','delivery']) this.querySelector('input[name="cmp-' + name + '"][value="' + e.querySelector('input[name="pcc-' + name + '"]:checked').value + '"]').checked = true;
      this.previousOverflow = document.body.style.overflow;
      this.dialog.showModal();
      document.body.style.overflow = 'hidden';
      this.showStep(1);
      e.updateDock();
    }
    syncToExplorer() {
      if (!this.quote) return;
      const selected = this.checked('quantity');
      this.explorer.querySelector('input[name="pcc-quantity"][value="' + selected + '"]').checked = true;
      if (selected === 'custom') this.explorer.querySelector('[data-custom-kg]').value = this.querySelector('#pcc-compose-kg').value;
      for (const name of ['pack','delivery']) this.explorer.querySelector('input[name="pcc-' + name + '"][value="' + this.checked(name) + '"]').checked = true;
      this.explorer.renderQuote(false);
    }
    showStep(step) {
      this.step = Math.max(1, Math.min(3, step));
      this.querySelectorAll('[data-compose-panel]').forEach(panel => {panel.hidden = Number(panel.dataset.composePanel) !== this.step;});
      this.querySelectorAll('[data-progress]').forEach(item => {
        item.classList.toggle('is-complete', Number(item.dataset.progress) < this.step);
        if (Number(item.dataset.progress) === this.step) item.setAttribute('aria-current', 'step');
        else item.removeAttribute('aria-current');
      });
      this.querySelector('[data-compose-back]').hidden = this.step === 1;
      this.querySelector('[data-compose-next]').hidden = this.step === 3;
      this.querySelector('[data-compose-finish]').hidden = this.step !== 3;
      this.set('[data-compose-next]', this.t(this.step === 1 ? 'compose_next_coffees' : 'compose_next_review'));
      this.render();
      this.dialog.scrollTop = 0;
      this.querySelector('#pcc-compose-heading' + this.step).focus({preventScroll:true});
    }
    capacity(size) { return this.quote ? (size === 1000 ? this.quote.bigBags : this.quote.smallBags) : 0; }
    count(size) {
      if (!this.capacity(size)) return 0;
      return [...this.querySelectorAll('[data-bag-count][data-size="' + size + '"]')].reduce((total, field) => total + (field.value === '' ? 0 : field.valueAsNumber), 0);
    }
    allocationValid() {
      return !!this.quote && [1000,500].every(size => {
        if (!this.capacity(size)) return true;
        const fields = [...this.querySelectorAll('[data-bag-count][data-size="' + size + '"]')];
        return fields.every(field => field.value === '' || (Number.isSafeInteger(field.valueAsNumber) && field.valueAsNumber >= 0)) && this.count(size) === this.capacity(size);
      });
    }
    canContinue() { return !!this.quote && (this.step !== 2 || this.allocationValid()); }
    packText(big, small) {
      const parts = [];
      if (big) parts.push(this.t(big === 1 ? 'd_pack_big_one' : 'd_pack_big_many', {count:big}));
      if (small) parts.push(this.t(small === 1 ? 'd_pack_small_one' : 'd_pack_small_many', {count:small}));
      return parts.join(this.t('d_pack_join'));
    }
    render() {
      const custom = this.checked('quantity') === 'custom';
      const field = this.querySelector('#pcc-compose-kg');
      const amount = custom ? field.valueAsNumber * 1000 : Number(this.checked('quantity'));
      const valid = this.validQuantity(amount, custom ? 2500 : 500);
      this.querySelector('[data-compose-custom]').hidden = !custom;
      this.querySelector('[data-compose-quantity-error]').hidden = valid;
      field.setAttribute('aria-invalid', String(custom && !valid));
      this.querySelector('[data-compose-step="-500"]').disabled = valid && amount <= 2500;
      if (custom && valid) this.lastCustomGrams = amount;
      this.quote = valid ? this.explorer.constructor.quote(amount, this.checked('delivery'), this.checked('pack')) : null;
      this.querySelector('[data-compose-next]').disabled = !this.canContinue();
      const summary = this.querySelector('.pcc-compose-summary');
      summary.hidden = !valid;
      if (!valid) {
        this.set('[data-compose-cadence]', this.t('compose_invalid'));
        this.set('[data-compose-mobile-total]', '—');
        this.set('[data-compose-mobile-period]', this.t('compose_invalid'));
        this.set('[data-compose-status]', this.t('compose_invalid'));
        return;
      }
      const q = this.quote;
      const period = this.t(q.months === 2 ? 'd_bimonthly' : 'd_monthly');
      const packs = this.packText(q.bigBags, q.smallBags);
      this.querySelector('[data-compose-pack]').hidden = amount === 500;
      this.querySelector('[data-compose-fixed]').hidden = amount !== 500;
      this.set('[data-compose-cadence]', this.t('compose_cadence', {weight:this.weight(q.shipmentGrams),period}));
      this.set('[data-compose-quantity]', this.t('d_quantity', {weight:this.weight(amount)}));
      this.set('[data-compose-total]', this.money(q.total));
      this.set('[data-compose-mobile-total]', this.money(q.total));
      this.set('[data-compose-mobile-period]', period);
      const status = this.t('live_update', {amount:this.money(q.total),period});
      if (this.querySelector('[data-compose-status]').textContent !== status) this.set('[data-compose-status]', status);
      this.set('[data-compose-period]', period);
      this.set('[data-compose-average]', this.t('d_average', {amount:this.money(q.monthly)}));
      this.querySelector('[data-compose-average]').hidden = q.months === 1;
      this.set('[data-compose-shipment]', this.t('d_shipment', {weight:this.weight(q.shipmentGrams),packs}));
      this.set('[data-compose-coffee]', this.money(q.coffee));
      this.set('[data-compose-shipping]', q.shipping ? this.money(q.shipping) : this.t('free'));
      this.set('[data-compose-relay]', q.shipmentGrams >= 1500 ? this.t('free') : this.money(290));
      this.set('[data-compose-home]', q.shipmentGrams >= 1500 ? this.t('free') : this.money(500));
      this.set('[data-compose-shipping-benefit]', this.t(q.shipping ? 'compose_shipping_paid' : 'compose_shipping_free'));
      this.querySelectorAll('[data-bag-row]').forEach(row => {row.hidden = !this.capacity(Number(row.dataset.bagRow));});
      this.querySelectorAll('[data-bag-count]').forEach(input => {
        const cap = this.capacity(Number(input.dataset.size));
        input.max = String(cap);
        const value = input.value === '' ? 0 : input.valueAsNumber;
        input.setAttribute('aria-invalid', String(cap > 0 && (!Number.isSafeInteger(value) || value < 0 || value > cap)));
      });
      this.querySelectorAll('[data-bag-change]').forEach(button => {
        const input = this.querySelector('#pcc-bag-' + button.dataset.coffee + '-' + button.dataset.size);
        const size = Number(button.dataset.size);
        button.disabled = Number(button.dataset.bagChange) < 0 ? !(input.valueAsNumber > 0) : this.count(size) >= this.capacity(size);
      });
      const complete = this.allocationValid();
      const data = {big:this.count(1000),bigTotal:q.bigBags,small:this.count(500),smallTotal:q.smallBags};
      const hasBadCount = ![data.big,data.small].every(Number.isSafeInteger) || [...this.querySelectorAll('[data-bag-count][aria-invalid="true"]')].length > 0;
      const allocation = hasBadCount ? this.t('compose_allocation_error') : this.t(q.bigBags && q.smallBags ? 'compose_allocation' : q.bigBags ? 'compose_allocation_big' : 'compose_allocation_small', data);
      this.set('[data-compose-allocation]', complete ? this.t('compose_allocation_done') : allocation);
      this.querySelector('[data-compose-allocation]').classList.toggle('is-complete', complete);
      this.querySelector('[data-compose-allocation]').classList.toggle('is-error', hasBadCount || data.big > q.bigBags || data.small > q.smallBags);
      const review = this.querySelector('[data-compose-review]');
      review.replaceChildren();
      this.querySelectorAll('[data-coffee-card]').forEach(card => {
        const values = [1000,500].map(size => this.capacity(size) ? Number(card.querySelector('[data-bag-count][data-size="' + size + '"]').value) : 0);
        card.classList.toggle('is-selected', values.some(v => v > 0));
        if (values.some(v => v > 0)) {
          const item = document.createElement('li');
          item.textContent = this.t('compose_review_line', {coffee:card.querySelector('[data-coffee-name]').textContent,packs:this.packText(...values)});
          review.append(item);
        }
      });
      this.set('[data-compose-grind-summary]', this.t('compose_grind_summary', {grind:this.t(this.checked('grind') === 'grain' ? 'compose_grain' : 'compose_ground')}));
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pc-entry"]) return;
  try {
    
  if (!customElements.get('pc-entry')) {
    customElements.define('pc-entry', class extends HTMLElement {
      connectedCallback() {
        if (!('IntersectionObserver' in window)) return;
        this.observer = new IntersectionObserver(entries => {
          this.toggleAttribute('data-visible', entries[0].isIntersecting && !document.documentElement.classList.contains('pc-entry-dismissed'));
        }, {rootMargin:'-112px 0px 0px 0px'});
        this.observer.observe(this);
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pc-pro-boulangerie"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initBakeryGroup(sectionSelector, tabSelector, panelSelector, readyKey, scrollOnClick) {
    const root = document.querySelector('.page-boulangerie');
    const section = root && root.querySelector(sectionSelector);
    if (!section || root.dataset[readyKey]) return;
    root.dataset[readyKey] = 'true';
    const tabs = Array.from(section.querySelectorAll(tabSelector));
    const panels = Array.from(section.querySelectorAll(panelSelector));
    const hashOf = link => new URL(link.getAttribute('href'), location.href).hash;
    function selectOffer(hash, scroll) {
      if (!panels.some(panel => '#' + panel.id === hash)) return;
      tabs.forEach(tab => {
        const selected = hashOf(tab) === hash;
        tab.setAttribute('aria-selected', String(selected));
        tab.setAttribute('aria-controls', hashOf(tab).slice(1));
        tab.tabIndex = selected ? 0 : -1;
      });
      panels.forEach(panel => {
        panel.hidden = '#' + panel.id !== hash;
        panel.classList.remove('is-entering');
      });
      if (scroll) requestAnimationFrame(() => section.scrollIntoView({
        block: 'start',
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      }));
    }
    root.addEventListener('click', event => {
      const link = event.target.closest('a[href]');
      if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const url = new URL(link.getAttribute('href'), location.href);
      if (url.origin !== location.origin || url.pathname !== location.pathname ||
          !panels.some(panel => '#' + panel.id === url.hash)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      selectOffer(url.hash, scrollOnClick);
      if (location.hash !== url.hash) history.pushState(null, '', url.hash);
    }, true);
    root.addEventListener('keydown', event => {
      const index = tabs.indexOf(event.target.closest(tabSelector));
      if (index < 0) return;
      let next;
      if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
      else if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = tabs.length - 1;
      else return;
      event.preventDefault();
      event.stopImmediatePropagation();
      selectOffer(hashOf(tabs[next]), false);
      tabs[next].focus({preventScroll: true});
    }, true);
    window.addEventListener('hashchange', () => selectOffer(location.hash, true));
    requestAnimationFrame(() => selectOffer(location.hash, Boolean(location.hash)));
  }
  function initBakeryOffers() {
    initBakeryGroup('#pc-boulangerie-solutions', '.offer-tab', '.offer-panel', 'offerNavigationReady', true);
    initBakeryGroup('#pc-boulangerie-opportunites', '.moment-tabs .experience-tab', '.moment-panel', 'momentNavigationReady', false);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initBakeryOffers, {once: true});
  else initBakeryOffers();
  document.addEventListener('shopify:section:load', initBakeryOffers);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pc-savoir-faire-fraicheur"] && !Shopify.designMode) return;
  try {
    
(function () {
  let active = null;
  const chaptersFor = section => Array.from(section.querySelectorAll('.pc-sf__feature, .pc-sf__card')).filter(card => card.querySelector('[data-pc-sf-open]'));
  const render = index => {
    if (!active) return;
    const { dialog, cards } = active;
    active.index = Math.max(0, Math.min(index, cards.length - 1));
    const card = cards[active.index];
    const original = card.querySelector('.pc-sf__photo');
    const visual = dialog.querySelector('[data-pc-sf-image]');
    const srcset = original.getAttribute('srcset');
    visual.src = original.currentSrc || original.getAttribute('src');
    if (srcset) visual.setAttribute('srcset', srcset);
    else visual.removeAttribute('srcset');
    visual.sizes = '(max-width: 749px) 100vw, 52vw';
    visual.alt = original.alt || '';
    dialog.querySelector('[data-pc-sf-title]').replaceChildren(...Array.from(card.querySelector('h3').childNodes, node => node.cloneNode(true)));
    const copy = card.querySelector('.pc-sf__feature-copy p, .pc-sf__card-copy p');
    dialog.querySelector('[data-pc-sf-short]').textContent = copy ? copy.textContent.trim() : '';
    const detail = card.querySelector('.pc-sf__detail');
    dialog.querySelector('[data-pc-sf-detail]').textContent = detail ? detail.textContent.trim() : '';
    const progress = String(active.index + 1).padStart(2, '0') + ' / ' + String(cards.length).padStart(2, '0');
    dialog.querySelector('[data-pc-sf-count]').textContent = progress;
    dialog.querySelector('[data-pc-sf-image-step]').textContent = progress;
    const captions = ['', '', 'Une date de torréfaction inscrite à la main.', 'Des sachets avec valve et zip hermétique.', 'Un café moulu juste avant l’achat.'];
    const caption = dialog.querySelector('[data-pc-sf-caption]');
    caption.textContent = captions[active.index] || '';
    caption.hidden = !caption.textContent;
    dialog.querySelector('[data-pc-sf-prev]').disabled = active.index === 0;
    dialog.querySelector('[data-pc-sf-next]').disabled = active.index === cards.length - 1;
  };
  document.addEventListener('click', event => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const trigger = target.closest('[data-pc-sf-open]');
    if (trigger) {
      const section = trigger.closest('.pc-sf');
      if (!section) return;
      const dialog = section.querySelector('.pc-sf__dialog');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      const cards = chaptersFor(section);
      const index = cards.findIndex(card => card.contains(trigger));
      if (index < 0) return;
      active = { dialog, cards, index };
      render(index);
      if (!dialog.open) dialog.showModal();
      dialog.querySelector('[data-pc-sf-close]').focus();
      return;
    }
    if (!active || !active.dialog.open) return;
    if (target.closest('[data-pc-sf-close]') || target === active.dialog) {
      active.dialog.close();
      active = null;
      return;
    }
    if (target.closest('[data-pc-sf-prev]')) render(active.index - 1);
    else if (target.closest('[data-pc-sf-next]')) render(active.index + 1);
  });
  document.addEventListener('keydown', event => {
    if (!active || !active.dialog.open) return;
    if (event.key === 'ArrowRight' && active.index < active.cards.length - 1) {
      render(active.index + 1);
      event.preventDefault();
    } else if (event.key === 'ArrowLeft' && active.index > 0) {
      render(active.index - 1);
      event.preventDefault();
    }
  });
  document.addEventListener('close', event => {
    if (active && event.target === active.dialog) active = null;
  }, true);
  document.addEventListener('scroll', event => {
    const track = event.target;
    if (!(track instanceof Element) || !track.classList.contains('pc-sf__journey')) return;
    const progress = track.closest('.pc-sf')?.querySelector('[data-pc-sf-progress]');
    if (!progress) return;
    const cards = chaptersFor(track.closest('.pc-sf'));
    const left = track.getBoundingClientRect().left + 20;
    let index = 0;
    let closest = Infinity;
    cards.forEach((card, i) => {
      const dist = Math.abs(card.getBoundingClientRect().left - left);
      if (dist < closest) { closest = dist; index = i; }
    });
    progress.textContent = String(index + 1).padStart(2, '0') + ' / ' + String(cards.length).padStart(2, '0');
  }, true);
})();

  } catch(e) { console.error(e); }
})();
})();
